import { ExecutionContext, RuleSet } from 'styled-components/dist/types'

import { AtLeastOnePartial } from '@/types/type-handlers'

type StyledWhenConditions = AtLeastOnePartial<{
  isHpx?: boolean
  isSmallville?: boolean
}>

const attendsConditions = (
  conditions: StyledWhenConditions,
  theme: ExecutionContext['theme'],
) => {
  if (!conditions) return true
  return (Object.keys(conditions) as Array<keyof StyledWhenConditions>).reduce(
    (evaluation, condition) => {
      return evaluation && conditions[condition] === theme[condition]
    },
    true,
  )
}

/**
 * Applies style rules when the conditions are attended
 *
 * @param conditions object key-value (boolean) to define when to apply the styles
 * @param styles Style rules to be applied when conditions are attended
 *
 * @example
 * Applying styles for HPX UI:
 * ```tsx
 * const Container = styled.div`
 *   display: flex;
 *   color: lightgrey;
 *
 *   ${applyStylesWhen({ isHpx: true }, css`
 *     color: lightskyblue;
 *   `)}
 * `
 * ```
 */
export const applyStylesWhen =
  (conditions: StyledWhenConditions, styles: RuleSet<object>) =>
  ({ theme }: ExecutionContext) =>
    attendsConditions(conditions, theme) && styles
